import './App.css';
import React from 'react';
import Layout from './Component/Layout';
import Home from './Component/Home';
import About from './Component/About';
import Privacy from './Component/Privacy';
import Payments from './Component/Payments';
import Order from './Component/Order';
import OrderDetails from './Component/OrderDetails';
import Checkout from './Component/Checkout';
import ErrorPage from './Component/ErrorPage';
import ThankYou from './Component/ThankYou';
import Shop from './Component/Shop';
import ShopDetail from './Component/ShopDetail';
import Blog from './Component/Blog';
import BlogDetails from './Component/BlogDetails';
import BlogLeftSidebar from './Component/BlogLeftSidebar';
import BlogRightSidebar from './Component/BlogRightSidebar';
import Faq from './Component/Faq';
import TermsConditions from './Component/TermsConditions';
import Contact from './Component/Contact';
import Account from './Component/Account';
import Cart from './Component/Cart';
import Login from './Component/Login';
import Register from './Component/Register';
import Wishlist from './Component/Wishlist';
import Footer from './Component/Footer';

import {BrowserRouter, Routes, Route } from 'react-router-dom';
function App() {
  return (
    <>
    <BrowserRouter basename='/tm/react/toolways'>
      <Layout/>
      <Routes>
        <Route path='/' element={<Home/>}></Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/privacy' element={<Privacy/>}></Route>
        <Route path='/payment' element={<Payments/>}></Route>
        <Route path='/order' element={<Order/>}></Route>
        <Route path='/order-details' element={<OrderDetails/>}></Route>
        <Route path='/error' element={<ErrorPage/>}></Route>
        <Route path='/thankyou' element={<ThankYou/>}></Route>
        <Route path='/shop' element={<Shop/>}></Route>
        <Route path='/shop-details' element={<ShopDetail/>}></Route>
        <Route path='/blog' element={<Blog/>}></Route>
        <Route path='/blog-details' element={<BlogDetails/>}></Route>
        <Route path='/blog-left' element={<BlogLeftSidebar/>}></Route>
        <Route path='/blog-right' element={<BlogRightSidebar/>}></Route>
        <Route path='/faqs' element={<Faq/>}></Route>
        <Route path='/terms-conditions' element={<TermsConditions/>}></Route>
        <Route path='/account' element={<Account/>}></Route>
        <Route path='/checkout' element={<Checkout/>}></Route>
        <Route path='/cart' element={<Cart/>}></Route>
        <Route path='/login' element={<Login/>}></Route>
        <Route path='/register' element={<Register/>}></Route>
        <Route path='/wishlist' element={<Wishlist/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
      </Routes>
      <Footer/>
      </BrowserRouter>
    </>
  );
}

export default App;
